module.exports = __webpack_public_path__ + "static/media/thumb-vannya-me.bcef9a50.png";